<template>
  <MultiSelect class="me-2 min-heig-multiselect" mode="single" :searchable="true" :options="data" :close-on-select="true"
    :clear-on-select="false" trackBy="name" valueProp="viewId"  v-model="selectedView" :object="true" label="name" placeholder="Visões"
    @select="changeView" @clear="clear" style="width: 200px;" ref="inputMulti">
    
    <template v-slot:clear="{ clear }">
      <!--
        Eram dois `<span aria-hidden="true" tabindex="0" role="button">`, o que é uma
        contradição direta: `tabindex="0"` põe o elemento na ordem de tabulação e
        `aria-hidden="true"` o remove da árvore de acessibilidade. O Tab parava neles e o
        leitor de tela não tinha nada para anunciar — "botão" sem nome, ou silêncio.

        Também traziam `aria-roledescription="❎"`: esse atributo substitui o NOME DO
        PAPEL anunciado ("botão") por um texto legível, e recebia um emoji — o leitor de
        tela anunciaria "❎" no lugar de "botão".

        Agora são `<button>` de verdade, com nome próprio. Foco, Enter e Espaço passam a
        ser do navegador; nada de role, tabindex ou tratamento de teclado manual.
      -->
      <button type="button" @click="clear()" class="multiselect-clear"
        aria-label="Limpar a visão selecionada" title="Limpar a visão selecionada">
        <span class="multiselect-clear-icon" aria-hidden="true"></span>
      </button>
      <button type="button" @click="deleteView" class="multiselect-clear"
        aria-label="Excluir a visão selecionada" title="Excluir a visão selecionada">
        <span style="color:red" class=" mdi mdi-trash-can-outline" aria-hidden="true"></span>
      </button>

    </template>

  </MultiSelect>
  <button type="button" title="Nova visão" class="btn btn-primary btn-sm " @click="salvarView" aria-label="Nova visão"><span
      class="ri-menu-add-line"
      aria-hidden="true"></span></button>

</template>
<script lang="ts">
import { ConsulteGridColumnsModel } from "@/datasources/consulte-grid";
import { useStore } from "@/store";
import { GridActionTypes } from "@/store/grid/action-types";
import Swal from "sweetalert2";
import { defineComponent } from "vue";
import { mapActions } from "vuex";
export default defineComponent({
  name: "ConsulteGridViews",

  emits: ["onSelectView", "update:columns"],
  async mounted() {
    this.selectedView = this.views?.find((x:any)=> x.viewId == this.getGrid.selectedView);
    this.data = this.views;
  },

  data() {

    return {
      filterAux: {} as any,
      filtersData: {} as any,
      loading: true,
      selectedView: null as null | any,
      data: [] as any[] 
    };
  },
  computed: {
    visibleColumns() {
      return this.columns?.filter(x => !x.hidden);
    },
    grouped() {
      return this.groupBy(this.columns!, "columngroup");
    },
    getGrid() {
      let grid = useStore().getters.getGrids[this.$route.name as string];
      return grid ? grid : { filters: {}, views: [] };
    },
    views():any[] {

      if (this.getGrid){
        return Object.assign([], this.getGrid.views);
      }

      return [];
    }


  },
  methods: {
    ...mapActions([GridActionTypes.SET_FILTER, GridActionTypes.CLEAR_FILTERS, GridActionTypes.SET_VIEW, GridActionTypes.ADD_VIEW, GridActionTypes.DELETE_VIEW, GridActionTypes.GET_GRID]),
    toJson(data: any) {
      return JSON.stringify(data);
    },
    onClickCheckBox() {
      this.$emit("update:columns", this.columns);
      console.log(this.columns)
    },
    groupBy(array: Array<any>, key: string) {
      return array.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    async salvarView() {
      Swal.fire({
        title: "Descrição da View",
        input: "text",
        inputAttributes: {
          autocapitalize: "off"
        },
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        preConfirm: async (msg) => {
          try {
            const viewId = msg.replace(" ", "").trim();
            if (!viewId) {
              return Swal.showValidationMessage(`Descrição é obrigatória!`);
            }

            if (this.views.find(x=> x.viewId == viewId)) {
              return Swal.showValidationMessage(`Já existe uma visão com o nome especificado!`);
            }


            console.log(this.getGrid);
            let filters = this.getGrid.filters;
            let view = {
              viewId: msg.replace(" ", "").trim(),
              name: msg,
              columns: this.columns!.map((x: any) => { return { datafield: x.datafield, hidden: x.hidden } }),
              filters: filters
            }
            this[GridActionTypes.ADD_VIEW]({ grid: this.$route.name, view: view });
            this.data = Object.assign([], this.views);
          }
          catch {
            Swal.showValidationMessage(`Erro, tente novamente!`);
          }
        },
        allowOutsideClick: () => !Swal.isLoading()
      });

    },
    deleteView() {
      this[GridActionTypes.DELETE_VIEW]({ grid: this.$route.name, viewId: this.selectedView.viewId });
      this[GridActionTypes.SET_VIEW]({ grid: this.$route.name, viewId: null })
      this.$emit("onSelectView", null);
      this.selectedView = null;
      this.data = Object.assign([], this.views);
    },
    changeView() {

      this[GridActionTypes.SET_VIEW]({ grid: this.$route.name, viewId: this.selectedView?.viewId??null })
      this.$emit("onSelectView", this.selectedView ?? null);

    },
    clear() {
      this[GridActionTypes.SET_VIEW]({ grid: this.$route.name, viewId: null });
      this.$emit("onSelectView", null);
    }

  },
  props: {
    columns: {
      type: Object as () => Array<ConsulteGridColumnsModel>
    },
  },
});
</script>
<style lang="scss">
.min-heig-multiselect{
--ms-line-height: 0.7;
--ms-font-size: 1rem;
}

</style>